module.exports = __webpack_public_path__ + "img/grey-detail.0495458a.png";